export class DealerSubventionEntityIdDto {

    portfolioId: number;
    quotationId: string;

}